import {
	sendSubmissionQuery,
	useAxiosInstance,
	usePoMutation,
} from '@gov-nx/api';
import type {
	PPPTerminateProps,
	PPPTerminateReturnType,
} from './terminate.types';
import { prepareSubmitData } from './prepareSubmitData';
import { usePPPLocale } from '../../../usePPPLocale';
import { useMessageEvents } from '@gov-nx/core/events';
import { useNavigate } from 'react-router-dom';
import { serviceRouteResolver } from '@gov-nx/web';

export const usePPPTerminate = ({
	pppId,
	serviceName,
	authContext,
}: PPPTerminateProps): PPPTerminateReturnType => {
	const { axiosInstance } = useAxiosInstance();
	const { t } = usePPPLocale();
	const { toastMessageSuccess } = useMessageEvents();
	const navigate = useNavigate();

	const mutation = usePoMutation({
		mutationKey: ['ppp-terminate', pppId],
		mutationFn: () =>
			sendSubmissionQuery(axiosInstance)(prepareSubmitData(pppId)),
		onSuccess: (data) => {
			const nonHighAuthorizationFlow = () => {
				toastMessageSuccess(t('ukonceni.message.ukonceno'));
				navigate(serviceRouteResolver('PPP'));
			};

			if (authContext) {
				authContext.onInitAuthorization(
					serviceName,
					data.headers['x-autorizaceid'] as string | undefined,
					nonHighAuthorizationFlow
				);
			} else {
				nonHighAuthorizationFlow();
			}
		},
	});

	return {
		terminate: () => mutation.mutate(),
		isTerminating: mutation.isLoading,
	};
};
